import {MENU_CONSTS} from "../constants";

export const initialState = {
    menuList: [],
    menuById: null,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case MENU_CONSTS.GET_MENUS:
            return {
                ...state,
                menuList: action.payload || [],
            };
        case MENU_CONSTS.GET_MENU_BY_ID:
            return {
                ...state,
                menuById: action.payload
            };
        case MENU_CONSTS.CREATE_MENU:
            return {
                ...state,
                menuList: [action.payload].concat(state.menuList)
            };
        case MENU_CONSTS.DELETE_MENU_BY_ID:
            return {
                ...state,
                menuList: state.menuList.filter(category => category.id !== action.payload)
            };
        default:
            return state;
    }
}
